const format = (value, format, lng) => {
  if (format === 'number' && !Number.isNaN(value * 1))
    return Intl.NumberFormat(lng).format(value)
  return value
}

export default format
